<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-tabs
                    v-model="activeTab"
                    v-if="value.status">
                <v-tab
                        v-for="(tab, idx) in tabItems"
                        :key="idx">
                    <v-list-item-title>{{ tab }}</v-list-item-title>
                </v-tab>
            </v-tabs>
            <v-list-item-title 
                    v-else
                    class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

        <template slot="edit-layout">
            <v-layout v-if="value.status && activeTab == 0" wrap>
                <v-flex>
                    <v-card flat>
                        <v-card-text>
                            <tree-view
                                    :data="status"
                                    :options="{
                                            rootObjectKey: 'status'
                                        }"
                            ></tree-view>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout v-else wrap>
                <v-flex shrink style="width: 180px;">
                    <v-card flat>
                        <v-card-text>
                            <v-text-field                                
                                    label="Name"
                                    v-model="value.object.metadata.name"
                                    autofocus
                                    :disabled="readOnly"
                            ></v-text-field>
                            <v-select
                                    label="Access Modes"
                                    v-model="value.object.spec.accessModes"
                                    :disabled="readOnly"
                                    :items="accessModeList">
                                <template v-slot:append-outer>
                                    <v-icon small @click="desDocOpen('#access-modes')">mdi-help-circle-outline</v-icon>
                                </template>
                            </v-select>
                            <v-label>Storage</v-label>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            v-model="storageVolume"
                                            :disabled="readOnly"
                                            type="number">
                                    </v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-select
                                            :items="units"
                                            v-model="storageUnit"
                                            :disabled="readOnly"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-select
                                    label="Reclaim Policy"
                                    v-model="value.object.spec.persistentVolumeReclaimPolicy"
                                    :disabled="readOnly"
                                    :items="policyList">
                                <template v-slot:append-outer>
                                    <v-icon small @click="desDocOpen('#reclaim-policy')">mdi-help-circle-outline</v-icon>
                                </template>
                            </v-select>
                            <v-select
                                    label="Volume Mode"
                                    v-model="value.object.spec.volumeMode"
                                    :disabled="readOnly"
                                    :items="volumeModeList">
                                <template v-slot:append-outer>
                                    <v-icon small @click="desDocOpen('#volume-mode')">mdi-help-circle-outline</v-icon>
                                </template>
                            </v-select>
                            <kube-attr-field 
                                    v-model="value" 
                                    :readOnly="readOnly"
                            ></kube-attr-field>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex>
                    <kube-yaml-editor
                            v-model="value.object"
                            :readOnly="readOnly"
                    ></kube-yaml-editor>
                </v-flex>
            </v-layout>
        </template>
    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        mixins: [KubernetesPanel],
        name: 'pv-property-panel',
        computed: {
            descriptionText() {
                return 'PersistentVolume'
            },
            status() {
                return JSON.parse(JSON.stringify(this.value.status))
            },
            storageVolume: {
                get() {
                    var val = this.value.object.spec.capacity.storage
                    val = val.replace(/Mi|Gi/gi, '')
                    return val
                },
                set(val) {
                    this.value.object.spec.capacity.storage = val + this.storageUnit;
                }
            },
            storageUnit: {
                get() {
                    var val = this.value.object.spec.capacity.storage;
                    val = val.replace(/[0-9]/g, '');
                    return val;
                },
                set(val) {
                    var storage = this.value.object.spec.capacity.storage;
                    storage = storage.replace(/Mi|Gi/gi, val);
                    this.value.object.spec.capacity.storage = storage;
                }
            },
        },
        data: function () {
            return {
                accessModeList: [ ['ReadWriteOnce'], ['ReadOnlyMany'], ['ReadWriteMany'] ],
                policyList: [ "Retain", "Recycle", "Delete" ],
                volumeModeList: [ "Filesystem", "Block" ],
                activeTab: 0,
                tabItems: [ "status", "property" ],
                units: [ 'Mi', 'Gi' ],
            }
        },
        watch: {
            status: {
                deep: true,
                handler: function () {
                }
            },
        },
        methods: {
           desDocOpen(property) {
                var url = 'https://kubernetes.io/docs/concepts/storage/persistent-volumes/'
                if(property) {
                    url += property
                }
                window.open(url)
            },
        }
    }
</script>

